<svelte:options customElement={{
  tag: 'heading-block',
  shadow: 'none',
  props: {
    level: { reflect: true, type: 'Number' },
    text: { reflect: true, type: 'String' },
    variant: { reflect: true, type: 'String' },
    center: { reflect: true, type: 'Boolean' }
  }
}} />

<script>
  /**
   * heading1〜5：見出し
   * パーツライブラリ準拠の mod-head01〜05 構造
   * variant で装飾スタイルを切り替え
   * @prop {number} level - 見出しレベル 1〜5
   * @prop {string} text - 見出しテキスト（slot未使用時のフォールバック）
   * @prop {string} variant - 'default' | 'overline' | 'marker' | 'ribbon' | 'plain'
   * @prop {boolean} center - 中央寄せ（overline, plain のみ）
   */
  export let level = 2;
  export let text = '';
  export let variant = 'default';
  export let center = false;

  $: tag = `h${Math.min(Math.max(level, 1), 5)}`;
  $: clampedLevel = Math.min(Math.max(level, 1), 5);

  $: className = (() => {
    switch (variant) {
      case 'overline':
        return `mod-head-overline _h${clampedLevel}${center ? ' _center' : ''}`;
      case 'marker':
        return `mod-head-marker _h${clampedLevel}`;
      case 'ribbon':
        return `mod-head-ribbon _h${clampedLevel}`;
      case 'plain':
        return `mod-head-plain _h${clampedLevel}${center ? ' _center' : ''}`;
      default:
        return `mod-head0${clampedLevel}`;
    }
  })();
</script>

{#if variant === 'overline'}
  <div class={className}>
    <svelte:element this={tag}>
      {#if text}
        {@html text}
      {:else}
        <slot></slot>
      {/if}
    </svelte:element>
  </div>
{:else if variant === 'marker' || variant === 'ribbon'}
  <div class={className}>
    <svelte:element this={tag}>
      {#if text}
        {@html text}
      {:else}
        <slot></slot>
      {/if}
    </svelte:element>
  </div>
{:else if variant === 'plain'}
  <div class={className}>
    <svelte:element this={tag}>
      {#if text}
        {@html text}
      {:else}
        <slot></slot>
      {/if}
    </svelte:element>
  </div>
{:else}
  <svelte:element this={tag} class={className}>
    {#if text}
      {@html text}
    {:else}
      <slot></slot>
    {/if}
  </svelte:element>
{/if}
